<template>
    <div class="jxwj" v-loading.fullscreen.lock="loading">
        <p class="title">PDF配置</p>
        <el-form :label-position="labelPosition" label-width="350px" :model="formLabelAlign">
            <el-form-item label="是否嵌入绩效文件:">
                <el-switch v-model="formLabelAlign.jxwjEnabled" active-color="#13ce66" inactive-color="#ff4949" @change='carryJxwj'>
                </el-switch>
            </el-form-item>
            <el-form-item label="是否允许用户上传自定义pdf:">
                <el-switch v-model="formLabelAlign.customEnabled" active-color="#13ce66" inactive-color="#ff4949" @change='carryCustom'>
                </el-switch>
            </el-form-item>
            <el-form-item label="存储在这个时间之后生成的pdf:" class="configtime">
                    <el-date-picker v-model="pdftime"
                                    @change	="pdfConfigTime"
                                    :clearable="false"
                                    type="datetime"
                                    placeholder="选择日期时间">
                    </el-date-picker>
            </el-form-item>
            <el-form-item label="pdf的文件名格式:">
                <span class="ellipsis" style="color: #66c2ff; cursor: pointer" @click="doExpr()">{{formLabelAlign.expr}}</span>
            </el-form-item>
        </el-form>
        <div v-show="containerShow" class="mask">
            <div class="mask-c">
                <div ref="container" class="container"></div>
                <div class="footer">
                    <el-button type="primary" @click="saveExpr">保存</el-button>
                    <el-button @click="exprBack">返回</el-button>
                </div>
            </div> 
        </div> 
    </div>
</template>

<script>
    import {
        postPdfCarryJxwj,
        getPdfCarryJxwj,
        postPdfFileNameProfile,
        getPdfFileNameProfile,
        getCustomPdf,
        postCustomPdf,
        reBuildPdfProfile,
        getPdfProfile
    } from "@/api/zone.js";
    import * as monaco from "monaco-editor";
    export default {
        name: "jxwj",
        data() {
            return {
                pdftime: '',
                loading: false,
                containerShow: false,
                labelPosition: 'right',
                formLabelAlign: {
                    jxwjEnabled: false,
                    customEnabled: false,
                    expr: '点击输入'
                },
            };
        },
        mounted() {
            this.initEditor();
        },
        created() {
            this.init()
        },
        methods: {
            async pdfConfigTime(val) {
                let time = this.conversionTimeformaDate(this.pdftime)
                let res = await reBuildPdfProfile({ before: this.pdftime })
                if (res.status == 0) {
                    this.$message.success('修改成功')
                } else {
                    this.$message.error('修改pdf配置时间失败')

                }
            },
            doExpr() {
                this.containerShow = true;
                if (this.formLabelAlign.expr == '点击输入') {
                    this.editor.setValue("");
                } else {
                    this.editor.setValue(this.formLabelAlign.expr);
                }
            },
            saveExpr() {
                //编辑器的内容
                this.formLabelAlign.expr = this.editor.getValue()
                this.containerShow = false;
                postPdfFileNameProfile({
                    expr: this.formLabelAlign.expr
                }).then(res => {
                    if (res.status == 0) {
                        this.$message.success('修改成功')
                    }
                })
            },
            exprBack() {
                this.containerShow = false;
                this.editor.setValue("");
            },
            carryCustom(val){
                postCustomPdf({
                    enabled: val
                }).then(res => {
                    if (res.status == 0) {
                        this.$message.success('修改成功')
                    }
                })
            },
            carryJxwj(val) {
                postPdfCarryJxwj({
                    enabled: val
                }).then(res => {
                    if (res.status == 0) {
                        this.$message.success('修改成功')
                    }
                })
            },
            init() {
                getPdfCarryJxwj().then(res => {
                    if (res.status == 0) {
                        if (res.enabled) {
                            this.formLabelAlign.jxwjEnabled  = res.enabled
                        }
                    }
                })
                getPdfFileNameProfile().then(res => {
                    if (res.status == 0) {
                        if (res.expr) {
                            this.formLabelAlign.expr = res.expr
                        }

                    }
                })
                getCustomPdf().then(res=>{
                    if(res.status == 0){
                        if(res.enabled){
                            this.formLabelAlign.customEnabled  = res.enabled
                        }
                    }
                })
                //获取pdf的配置时间
                getPdfProfile().then(res => {
                    if (res.status == 0) {
                        this.pdftime = res.before
                    } else {
                        this.pdftime = ''
                    }
                })
            },
            initEditor() {
                this.editor = monaco.editor.create(this.$refs.container, {
                    value: "", //编辑器初始显示文字
                    language: "javascript", //语言支持自行查阅demo
                    selectOnLineNumbers: true, //显示行号
                    glyphMargin: true, //字形边缘
                    // autoIndent: true, //自动布局
                    automaticLayout: true, //自动布局
                    theme: "vs-dark", //官方自带三种主题vs, hc-black, or vs-dark
                });
            },
        },
    };
</script>

<style scoped>
    .configtime /deep/.el-input {
        width: 270px;
    }
    .jxwj {
        width: 100%;
        padding: 50px;
    }

    /deep/ .el-form-item__label {
        font-size: 20px;
        font-weight: bold;
    }

    .title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 50px;
    }

    .jxwj .mask {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }

        .jxwj .mask .mask-c {
            width: 70%;
            background-color: #fff;
            margin: 0 auto;
            margin-top: 1%;
            overflow: hidden;
        }

            .jxwj .mask .mask-c .container {
                height: 85vh;
                width: 90%;
                background-color: #000000;
                margin: 0 auto;
                margin-top: 2%;
            }

    .footer {
        float: right;
        margin: 2% 50px 10px 0;
    }

    .ellipsis {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
</style>
